export const AppVersion: string = 'v1.37.1';
